module.exports = __webpack_public_path__ + "static/img/weibo_code.1f5c47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weibo_code.png
// module id = zCt5
// module chunks = 1